import React from 'react';
import Typewriter from 'typewriter-effect';
import '../../CSS/LandingPage.css';

function LandingText() {
    return (
        <div className="Body">
            <Typewriter
                options={{
                    strings: ['Building Products That Empower Users', 
                        'Designing Systems to Scale Growth',
                        'Product, Data, and GTM Strategy',
                        'Ex-McKinsey, MBA + MS in Design'],
                    autoStart: true,
                    loop: true,
                    delay: 50,
                    deleteSpeed: 25,
                }}
            />
        </div>
    )
}

export default LandingText;